import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PAGING_HEADERS } from '@app/app.constants';
import { Result } from '@app/modules/reports/types/result.types';
import { ApiHeaders } from '@core/core.types';
import { HttpUtils } from '@core/utils/http-utils';
import { environment } from '@root/environments/environment';
import { IGNORED_STATUSES } from '@shared/interceptors/error.interceptor';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/digital-reports/raw-data`;

  constructor() {}

  getResult(resultId: string) {
    return this.http.get<Result>(`${this.apiUrl}/${resultId}`);
  }

  deleteResult(resultId: string) {
    return this.http.delete(`${this.apiUrl}/${resultId}`);
  }

  generateReport(resultId: string) {
    return this.http.post<{ id: string }>(
      `${this.apiUrl}/${resultId}/generate`,
      {},
      {
        context: new HttpContext().set(IGNORED_STATUSES, [400]),
      }
    );
  }

  listXlsVersions() {
    return this.http.get<
      {
        laboratory: string;
        type: string;
        versions: {
          label: string;
          version: string;
        }[];
      }[]
    >(`${this.apiUrl}/versions`);
  }

  listResults(filters: HttpParams, headers: ApiHeaders) {
    return this.http
      .get<Result[]>(`${this.apiUrl}`, {
        observe: 'response',
        params: filters,
        headers: HttpUtils.buildHttpHeaders(headers),
      })
      .pipe(
        map((response) => ({
          items: response.body,
          continuationToken: response.headers.get(
            PAGING_HEADERS.continuationToken
          ),
          totalCount: parseInt(
            response.headers.get(PAGING_HEADERS.totalCount),
            10
          ),
        }))
      );
  }

  archiveResult(resultId: string, archivedReason: string) {
    return this.http.put(`${this.apiUrl}/${resultId}/archive`, {
      archivedReason,
    });
  }
}
